<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">项目成员<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div v-for="type in partnerField" :key="type" class="card-content-select-item">
        <div class="project-detail-item" style="flex:auto">
          <b :class="[hasNotValueFields.includes(type) ? 'warning-text' : '']" style="flex: none;word-break: keep-all;"
            >{{ translate[type] || type }}:</b
          ><span>{{ (project[type] || []).join('、') }}</span>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">项目成员</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div v-for="type in partnerField" :key="type" class="card-content-select-item">
          <span :class="[hasNotValueFields.includes(type) ? 'warning-text' : '', 'field-label']">{{
            translate[type] || type
          }}</span>
          <div class="field-value">
            <div v-for="(item, index) in projectInEdit[type]" :key="index" class="member-select-item">
              <el-select
                v-model="projectInEdit[type][index]"
                class="mr5"
                filterable
                size="mini"
                @change="selectPartnet(type)"
              >
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner(type, index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === projectInEdit[type].length - 1" class="col-0 mr5" @click="addPartner(type)">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
            <div v-if="type === '项目经理' && categoryLeaders.length > 0">
              <el-button
                v-for="item in categoryLeaders"
                :key="item"
                style="margin:5px"
                size="mini"
                @click="quickAddManager(item)"
                >{{ item }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import mixin from './mixin'

export default {
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      partnerField: ['客户开发', '项目对接', '项目经理', '项目成员'],
      translate: { 项目对接: '客户对接' },
      accounts: [],
      fields: ['客户开发', '项目对接', '项目经理', '项目成员'],
    }
  },
  computed: {
    // accounts() {
    //   return window.app.accounts || []
    // },
    categoryLeaders() {
      const category = (app.categories || []).find(v => v.名称 === this.project.职能模块)
      return (category && category.负责人) || []
    },
  },
  async mounted() {
    if (!app.accounts) await app.getUsers()
    this.accounts = app.accounts || []
  },
  methods: {
    toEdit() {
      this.projectInEdit = {}
      this.fields.forEach(key => {
        const value = this.project[key] || []
        if (value && typeof value === 'object') {
          const newVal = JSON.parse(JSON.stringify(value))
          this.$set(this.projectInEdit, key, newVal)
        } else {
          this.$set(this.projectInEdit, key, value)
        }
        if(this.projectInEdit[key].length===0) this.projectInEdit[key].push('')
      })
      this.isEditing = true
      this.$emit('toEdit', this.componentType)
    },
    quickAddManager(item) {
      if (!this.projectInEdit.项目经理) this.$set(this.projectInEdit, '项目经理', [])
      if (!this.projectInEdit.项目经理.includes(item)) {
        if (this.projectInEdit.项目经理[this.projectInEdit.项目经理.length - 1]) this.projectInEdit.项目经理.push(item)
        else this.projectInEdit.项目经理.splice(this.projectInEdit.项目经理.length - 1, 1, item)
      }
    },
    selectPartnet(field) {
      const value = this.projectInEdit[field] || []
      const length = value.length
      if (length === 0 || value[length - 1]) value.push('')
    },
    addPartner(field) {
      const value = this.projectInEdit[field] || []
      value.push('')
    },
    removePartner(field, index) {
      const value = this.projectInEdit[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
